import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetMe'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetMeStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetMeStore",
			variables: false,
		})
	}
}

export async function load_GetMe(params) {
  await initClient()

	const store = new GetMeStore()

	await store.fetch(params)

	return {
		GetMe: store,
	}
}
